import { EMPTY_STRING } from 'constants/MeshbotConstant';

/**
 * Returns the user/PIN key of an isUserLockOperation trigger for SelectPinCode, read straight from
 * capabilityDynamicFields (O(1), no store lookup — existence was already resolved once at restore, see
 * getRestoredUserFieldValue). Shared by all value types of this method. Possible values:
 *   - "" — no key chosen yet: empty field, NO error;
 *   - the key — a valid PIN key: shown as selected;
 *   - null — an orphan key normalized at restore: empty field in ERROR state, forcing a re-select.
 * @param {Object} ruleTrigger - trigger from the store
 * @returns {string|null}
 */
export const getUserLockOperationUser = (ruleTrigger) => {
    const { userFieldValue } = ruleTrigger?.capabilityDynamicFields || {};

    return userFieldValue === undefined ? EMPTY_STRING : userFieldValue;
};
